export enum FlexibleTableError {
  VALUE_OR_CELL_RENDERER_MISSING = '[FlexibleTable]: cellRenderer nor value provided, please provide correct configuration for table',
}
